import { useEffect, useState } from 'react';
import './usermenu.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../utils/createScopedI18n';
import { mainLayoutI18n } from '../../layout/MainLayout/i18n';

export default function UserMenu({ user, onLogout, SvgIcon }) {
  const { language } = useLanguage();
  const mainLayoutLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: mainLayoutI18n });
  const [open, setOpen] = useState(false);

  const isSuperAdmin = user?.role === 'Super-Admin';

  useEffect(() => {
    mainLayoutI18n.changeLanguage(mainLayoutLanguage);
  }, [mainLayoutLanguage]);

  const initials = (user?.fullName || user?.name || '')
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const Avatar = ({ imageUrl, initials, size = 'md' }) => {
    return (
      <div
        className={`user-menu__avatar ${
          size === 'sm' ? 'user-menu__avatar--sm' : ''
        }`}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={t('user_menu_avatar_alt')}
            className='user-menu__avatar-img'
          />
        ) : (
          initials
        )}
      </div>
    );
  };

  return (
    <div className='user-menu'>
      <button
        type='button'
        className='user-menu__trigger'
        onClick={() => setOpen((prev) => !prev)}
      >
        <Avatar
          imageUrl={user?.profileImageUrl}
          initials={initials}
          size='sm'
        />

        <div className='user-menu__info'>
          <span className='user-menu__name'>{user?.name}</span>
          <span className='user-menu__role'>{user?.position}</span>
        </div>
        {SvgIcon && (
          <SvgIcon
            name={open ? 'chevronUp' : 'chevronDown'}
            size='16px'
            className='user-menu__chevron'
          />
        )}
      </button>

      {open && (
        <div className='user-menu__panel'>
          <div className='user-menu__header'>
            <Avatar imageUrl={user?.profileImageUrl} initials={initials} />
            <div>
              <div className='user-menu__name'>
                {user?.fullName || user?.name}
              </div>
              <div className='user-menu__email'>{user?.email}</div>
            </div>
          </div>

          <div className='user-menu__separator' />

          <Link
            to='/mi-perfil'
            className='user-menu__item text-decoration-none'
            onClick={() => setOpen(false)}
          >
            {SvgIcon && (
              <SvgIcon
                name='gear'
                size='16px'
                className='user-menu__item-icon'
              />
            )}
            <span>{t('user_menu_profile')}</span>
          </Link>

          {isSuperAdmin && (
            <Link
              to='/impersonate'
              className='user-menu__item text-decoration-none'
              onClick={() => setOpen(false)}
            >
              {SvgIcon && (
                <SvgIcon
                  name='eye'
                  size='16px'
                  className='user-menu__item-icon'
                />
              )}
              <span>{t('user_menu_impersonate')}</span>
            </Link>
          )}

          <button
            type='button'
            className='user-menu__item user-menu__item--danger'
            onClick={() => {
              setOpen(false);
              onLogout && onLogout();
            }}
          >
            {SvgIcon && (
              <SvgIcon
                name='boxArrowRight'
                size='16px'
                className='user-menu__item-icon'
              />
            )}
            <span>{t('user_menu_logout')}</span>
          </button>
        </div>
      )}
    </div>
  );
}
